import { render, staticRenderFns } from "./CommoditySeen.vue?vue&type=template&id=628190e9&scoped=true&"
import script from "./CommoditySeen.vue?vue&type=script&lang=ts&"
export * from "./CommoditySeen.vue?vue&type=script&lang=ts&"
import style0 from "./CommoditySeen.vue?vue&type=style&index=0&id=628190e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628190e9",
  null
  
)

export default component.exports